import React, { FC } from 'react';
import { TooltipLanguageCollapseItemContentProps } from 'modules/header/components/HeaderUserTooltip/types';
import classes from './styles/index.module.scss';
import { AngleDownSmall } from '../../../../../../ReactSharedScripts/components/Icons/AngleDownSmall';
import { AngleUpSmall } from '../../../../../../ReactSharedScripts/components/Icons/AngleUpSmall';

const TooltipLanguageCollapseItemContent: FC<TooltipLanguageCollapseItemContentProps> = ({
	image,
	name,
	isOpened,
	hasCollapse,
}) => {
	return (
		<>
			<img
				src={image}
				className={classes.tooltipIcon}
				alt='lang'
			/>
			<span className={classes.tooltipLanguageLabel}>{name}</span>
			{hasCollapse && (isOpened ? <AngleUpSmall /> : <AngleDownSmall />)}
		</>
	);
};

export { TooltipLanguageCollapseItemContent };
